var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('p',{staticClass:"black--text"},[_vm._v("Tools for working with Jonas exports")])])],1),_c('v-row',[_c('v-col',{attrs:{"cols":"5"}},[_c('BillingsTools')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }